import { createElement } from "react";
import LoginPage from "@pages/login";
import { LOGIN_PATH } from "@routes/path";
import type { AppRoute } from "@routes/types";

const LoginRoute: AppRoute[] = [
    {
        path: LOGIN_PATH,
        element: createElement(LoginPage),
        label: "Login",
    }
];

export default LoginRoute;